// Local storage utilities for shop preferences

const STORAGE_KEYS = {
  VIEW_MODE: 'shop_view_mode',
  ITEMS_PER_PAGE: 'shop_items_per_page',
  SORT_BY: 'shop_sort_by'
};

// Get saved preferences from localStorage
export const getShopPreferences = () => {
  try {
    const preferences = {
      viewMode: localStorage.getItem(STORAGE_KEYS.VIEW_MODE) || 'grid',
      itemsPerPage: parseInt(localStorage.getItem(STORAGE_KEYS.ITEMS_PER_PAGE)) || 9,
      sortBy: localStorage.getItem(STORAGE_KEYS.SORT_BY) || 'Sort by latest'
    };
    return preferences;
  } catch (error) {
    console.error('Error reading shop preferences from localStorage:', error);
    return {
      viewMode: 'grid',
      itemsPerPage: 9,
      sortBy: 'Sort by latest'
    };
  }
};

// Save view mode preference
export const saveViewMode = (viewMode) => {
  try {
    localStorage.setItem(STORAGE_KEYS.VIEW_MODE, viewMode);
  } catch (error) {
    console.error('Error saving view mode to localStorage:', error);
  }
};

// Save items per page preference
export const saveItemsPerPage = (itemsPerPage) => {
  try {
    localStorage.setItem(STORAGE_KEYS.ITEMS_PER_PAGE, itemsPerPage.toString());
  } catch (error) {
    console.error('Error saving items per page to localStorage:', error);
  }
};

// Save sort by preference
export const saveSortBy = (sortBy) => {
  try {
    localStorage.setItem(STORAGE_KEYS.SORT_BY, sortBy);
  } catch (error) {
    console.error('Error saving sort by to localStorage:', error);
  }
};